import { ReactNode, createContext, useEffect, useState } from 'react'
import { CopilotPresetSetting, CopilotPresetSettings } from '../types'
import { getDefaultPresetSettings } from '../utils/preset-setting'

export type CopilotSettingsContextProps = {
    settings: CopilotPresetSettings
    toggleSetting: (setting: CopilotPresetSetting) => void
}

export const CopilotSettingsContext = createContext({} as CopilotSettingsContextProps)

type Props = {
    children: ReactNode
    onChange?: (settings: CopilotPresetSettings) => void
}

const CopilotSettingsContextManager = ({ children, onChange }: Props) => {
    const [settings, setSettings] = useState<CopilotPresetSettings>(getDefaultPresetSettings())

    function toggleSetting(setting: CopilotPresetSetting) {
        setSettings((state) => {
            const newState = { ...state }

            newState[setting] = !newState[setting]

            return newState
        })
    }

    useEffect(() => {
        onChange?.(settings)
    }, [settings])

    return (
        <CopilotSettingsContext.Provider value={{ settings, toggleSetting }}>
            {children}
        </CopilotSettingsContext.Provider>
    )
}

export default CopilotSettingsContextManager
